module.exports = __webpack_public_path__ + "assets/img/2.55064e8d.png";